module.exports = __webpack_public_path__ + "static/media/screen5.cc5f896d.png";